import { gql } from '@apollo/client';

export const GET_MERGED_STATEMENT_VIEWS = gql`
    query getMergedStatementViews($ids: [ID!]) {
        getMergedStatementViews(ids: $ids) {
            id
            statement_id
            view {
                statement_info {
                    role_type
                    name
                    normed_statement_url
                    period {
                        end_date
                        start_date
                        unit
                    }
                    pro
                    statement_id
                    user_id
                }
            }
        }
    }
`;

export const GET_MERGED_TRACK_DATA = gql`
    query getMergedTrackData($song_id: ID!, $statement_ids: [ID!]) {
        getMergedTrackData(song_id: $song_id, statement_ids: $statement_ids) {
            composers
            earnings
            max_earnings_per_play
            min_earnings_per_play
            percent_share
            performance_contributions {
                duration
                earnings
                music_user_genre_name
                plays
                show_name
                source_name
                use_name
            }
            plays
            publishers
            show_name_contributions {
                earnings_contribution
                music_user_genre_name
                show_name
            }
            source_name_contributions {
                earnings_contribution
                music_user_genre_name
                plays_contribution
                source_name
            }
            subpublishers
            work_ids
        }
    }
`;
